var map = {
	"./DisputeResolution": [
		5740,
		[
			740
		]
	],
	"./DisputeResolution/": [
		5740,
		[
			740
		]
	],
	"./DisputeResolution/index": [
		5740,
		[
			740
		]
	],
	"./DisputeResolution/index.tsx": [
		5740,
		[
			740
		]
	],
	"./Home": [
		2882,
		[
			882
		]
	],
	"./Home/": [
		2882,
		[
			882
		]
	],
	"./Home/index": [
		2882,
		[
			882
		]
	],
	"./Home/index.tsx": [
		2882,
		[
			882
		]
	],
	"./PrivacyPolicy": [
		4444,
		[
			444
		]
	],
	"./PrivacyPolicy/": [
		4444,
		[
			444
		]
	],
	"./PrivacyPolicy/index": [
		4444,
		[
			444
		]
	],
	"./PrivacyPolicy/index.tsx": [
		4444,
		[
			444
		]
	],
	"./Team": [
		7205,
		[
			205
		]
	],
	"./Team/": [
		7205,
		[
			205
		]
	],
	"./Team/index": [
		7205,
		[
			205
		]
	],
	"./Team/index.tsx": [
		7205,
		[
			205
		]
	],
	"./TermsOfService": [
		1185,
		[
			185
		]
	],
	"./TermsOfService/": [
		1185,
		[
			185
		]
	],
	"./TermsOfService/index": [
		1185,
		[
			185
		]
	],
	"./TermsOfService/index.tsx": [
		1185,
		[
			185
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;